export default "__VITE_ASSET__32ad0fff__"